import { API_BASE_URL } from "../../../constants";

export function getProfile(token: String) {
  return fetch(`${API_BASE_URL}/profile?token=${token}`);
}
